module.exports = __webpack_public_path__ + "static/media/Like.8d0680fc.svg";